













import { Component, Vue, Model, Prop, Emit } from "vue-property-decorator";
import { VData } from "vuetify/lib";

@Component
export default class NumberButton extends Vue {
  @Prop({ required: true, type: Number })
  public number!: number;
  @Prop({ required: true, type: Boolean })
  public selected!: boolean;

  componentKey = 0;

  get color() {
    return this.selected ? "primary" : "lotojr_numberDisable";
  }

  change(number: any) {
    this.$emit("update:selected", !this.selected);
    this.$emit("onChange");
    this.componentKey += 1;
  }
}
